import { rem } from "polished";
import styled from "styled-components";

const HelperTextRoot = styled.div`
  margin-top: 8px;

  p {
    margin: 0;
    line-height: 1.25;
    font-size: ${rem(14)};
    font-weight: 500;
    font-style: italic;
  }
`;

const HelperTextText = styled.p`
  color: var(--gray-text);
`;

const HelperTextError = styled.p`
  padding-left: 8px;
  border-left: 2px solid var(--error-red);
  color: var(--error-red);
`;

const HelperText = Object.assign(HelperTextRoot, {
  Text: HelperTextText,
  Error: HelperTextError,
});

export default HelperText;
